goog.provide("shadow.js.shim.module$mime$types$standard");
goog.provide("module$shadow_js_shim_module$mime$types$standard");
shadow.js.shim.module$mime$types$standard = shadow.js.nativeProvides["mime/types/standard.js"] = shadow$bridge("mime/types/standard.js");
module$shadow_js_shim_module$mime$types$standard.default = shadow.js.shim.module$mime$types$standard;
